import { cn } from '@kit/ui/utils';

export function NrfMaterialIcon({
  materialName,
  materialType = 'outlined',
  filled = false,
  weight = 500,
  grade = 0,
  opticalSize = 24,
  className,
}: {
  materialName: string;
  materialType?: 'outlined' | 'rounded' | 'sharp';
  filled?: boolean;
  weight?: number;
  grade?: number;
  opticalSize?: number;
  className?: string;
}) {
  return (
    // text-[length:inherit] is needed to disable font size of material-symbols-${materialType}. So
    // Size is taken from parent class(es), and can be "set from outside" - Which is useful for
    // Components getting an icon from outside which should have a default size
    <div
      className={cn(
        `block h-fit w-fit material-symbols-${materialType} text-[length:inherit] text-primary`,
        className,
        'leading-none',
      )}
      style={{
        fontVariationSettings: `'FILL' ${filled ? 1 : 0}, 'wght' ${weight}, 'GRAD' ${grade}, 'opsz' ${opticalSize}`,
      }}
    >
      {materialName}
    </div>
  );
}
